import { Button, Heading, Stack } from '@sixfold/common-ui';

import { DeleteConfirmationModal } from './delete_confirmation_modal';

interface WebhookSubscriptionHeaderProps {
  isCreateMode: boolean;
  isEditing: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  showDeleteConfirm: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
  onDelete: () => void;
  onToggleDeleteConfirm: () => void;
}

export function WebhookSubscriptionHeader({
  isCreateMode,
  isEditing,
  isSaving,
  isDeleting,
  showDeleteConfirm,
  onEdit,
  onCancel,
  onSave,
  onDelete,
  onToggleDeleteConfirm,
}: WebhookSubscriptionHeaderProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Heading>{isCreateMode ? 'Create Webhook Subscription' : 'Webhook Subscription'}</Heading>
      <Stack direction="row" gap="small">
        {isEditing ? (
          <>
            <Button kind="neutral" onClick={onCancel} disabled={isSaving}>
              Cancel
            </Button>
            <Button kind="neutral" onClick={onSave} disabled={isSaving} loading={isSaving}>
              {isCreateMode ? 'Create' : 'Save'}
            </Button>
          </>
        ) : (
          <>
            <Button kind="neutral" iconStart="small-pencil" onClick={onEdit}>
              Edit
            </Button>
            {!isCreateMode && (
              <DeleteConfirmationModal
                open={showDeleteConfirm}
                onToggle={onToggleDeleteConfirm}
                onConfirm={onDelete}
                isDeleting={isDeleting}
              />
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
}
